import service from '@/services'

const state = {

}

const getters = {

}

const actions = {
  addBackEndMaster: ({commit}, payload) => {
    return service.addBackEndMaster(commit, payload)
  },
  enableOrDelete: ({commit}, payload) => {
    return service.enableOrDelete(commit, payload)
  },
  queryList: ({commit}, payload) => {
    return service.queryList(commit, payload)
  },
  addAccount: ({commit}, payload) => {
    return service.addAccount(commit, payload)
  },
  queryPartnerListToShow: ({commit}, payload) => {
    return service.queryPartnerListToShow(commit, payload)
  },
  queryAccount: ({commit}, payload) => {
    return service.queryAccount(commit, payload)
  }

}
const mutation = {}

export default {
  state,
  getters,
  actions,
  mutation
}



// WEBPACK FOOTER //
// ./src/store/modules/authority.js